function BottomBar() {
    return (
        <div className="sticky-bottom-bar">
            Powered by IXO Global P.O. Box 6247 Chattanooga, TN 37401
        </div>
    );
}

export default BottomBar;